/* toggle hidden/visible state of target element */
const toggleVisibility = (element, toggleVisibleClass, event) => {
  const thisElement = document.querySelector(element);
  const visibleClassName = 'visible';
  const isHidden = thisElement.hidden;
  event.preventDefault();

  if (thisElement && isHidden) {
    thisElement.hidden = false;
    if (toggleVisibleClass) {
      thisElement.classList.add(visibleClassName);
    }
  } else if (thisElement) {
    thisElement.hidden = true;
    if (toggleVisibleClass) {
      thisElement.classList.remove(visibleClassName);
    }
  }
};

/* toggle click handler */
const handleToggleClick = (source, target) => {
  const thisElement = document.querySelector(source);
  const thisTarget = document.querySelector(target);
  const isNotVisible = !!(thisTarget && window.getComputedStyle(thisTarget).display === 'none');

  /* set hidden attr if element is hidden via css */
  if (isNotVisible) {
    thisTarget.hidden = true;
  }

  if (thisElement && target) {
    thisElement.addEventListener('click', event => toggleVisibility(target, true, event));
  }
};

/* init toggle func */
document.addEventListener('DOMContentLoaded', () => {
  handleToggleClick('.list-filter__toggle:not(.js-dialog-trigger)', '#list-filter__inner');
});
